module.exports = __webpack_public_path__ + "static/media/telegram.e9722f26.png";